<template>
  <v-container>
    <h1>{{ title }}</h1>
    <h3>{{ date }}</h3>
    <template v-for="(para, i) in body.split('\n')">
      <p :key="i">{{ para }}</p>
    </template>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    title: 'Loading . . .',
    body: 'Loading . . .',
    date: null
  }),
  mounted: function () {
    let id = this.$route.params.id

    // Load data for this diary entry
    var _this = this
    this.axios.get('/diaries/' + id)
      .then(function (res) {
        _this.title = res.data[0].title
        _this.body = res.data[0].body

        let d = _this.$root.parseApiDateTimeString(res.data[0].created_at)
        _this.date = d.toLocaleDateString()
      })
      .catch(this.$root.apiErrorHandler(function (msg, errors, err) {
        // If our error is a 404, that means we got a bogus diary ID value and
        // we can safely abort back to the listing page. Otherwise, we want
        // to render our error message.
        if (err && err.response && err.response.status === 404) {
          return _this.$router.push('/diary')
        } else {
          return true
        }
      }))
  }
}
</script>
